var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-info-card',{attrs:{"title":"Archives"}},[_c('ul',{staticClass:"pl"},_vm._l((_vm.archives),function(archive){return _c('li',{key:archive,staticClass:"mb-3",domProps:{"textContent":_vm._s(archive)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }